/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import { isNumber, isNaN } from "lodash";
import { View } from "backbone.marionette";

import template from "templates/submission/evaluations/score_slider.hbs";

const jqueryUI = require("jquery-ui");

export default class ScoreSlider extends View.extend({
  template,
  baselineSnapDuration: 500,
  lowShim: 4,
  highShim: 4,
  tagName: "li",

  events: {
    "input @ui.input": "onInput",
    "change @ui.input": "onInputChange",
    "blur @ui.input": "onInputBlur"
  },

  ui: {
    range: '[data-behavior="range"]',
    score: '[data-behavior="score"]',
    placardTitle: '[data-behavior="placard-header"]',
    placardContent: '[data-behavior="placard-content"]',
    placard: '[data-behavior="placard"]',
    input: '[data-behavior="input"]'
  }
}) {
  showPlacard(e) {
    return this.getUI("placard").fadeIn();
  }

  hidePlacard(e) {
    return this.getUI("placard").hide();
  }

  currentPosition() {
    return this.getUI("grabber").position().left;
  }

  translateScoreToPercentage(score) {
    return (parseInt(score, 10) / parseInt(this.model.get("high"))) * 100;
  }

  updateScore(score) {
    return this.getUI("score").html(score);
  }

  updatePlacard(score) {
    if (isNumber(score) && !isNaN(score)) {
      const range = this.rubric.getRangeForScore(score);
      if (range != null) {
        const desc = this.rubric.getCellDescription(this.model.id, range.id);
        this.getUI("placardContent").html(desc);
        return this.getUI("placardTitle").html(range.get("name"));
      }
    }
  }

  onDestroy() {
    return $(window).off(`resize.score_slider_${this.cid}`);
  }

  initialize(options) {
    this.vent = options.vent;
    this.rubric = options.rubric;
  }

  onInput(e) {
    const value = e.target.value;
    this.model.set("score", value);
    this.model.set("percentage", this.translateScoreToPercentage(value));
    const range = this.getUI("range").get(0);
    range.style.setProperty("--value", value);
    this.showPlacard();
    this.updatePlacard(parseInt(value, 10));
    this.updateScore(e.target.value);
  }

  onInputChange(e) {
    return this.trigger("updated");
  }

  onInputBlur() {
    this.hidePlacard();
  }

  onRender() {
    // Set initial css vars on sliders
    const range = this.getUI("range").get(0);
    range.style.setProperty("--high", this.model.get("high") || 1);
    range.style.setProperty("--low", this.model.get("low"));
    range.style.setProperty("--value", this.model.get("score"));
  }

  serializeModel() {
    return this.model.toJSON();
  }
}
